// Base URL for RPM assets - can be overridden via environment variable
const RPM_ASSETS_BASE_URL = process.env.REACT_APP_RPM_ASSETS_BASE_URL || '';

export const patientAvatarLibrary: string[] = [
  "/rpm-assets/glb/65c2d56a5bfe15dcc69fa43b.glb",
  "/rpm-assets/glb/65c2f244bee65ecd7a17fd8a.glb",
  "/rpm-assets/glb/65c2f34dd58106ff3b9701ca.glb",
  "/rpm-assets/glb/65c2f3eed66c8232a09e8418.glb",
  "/rpm-assets/glb/65c2f490cb01177237fcf3ff.glb",
  "/rpm-assets/glb/65c2f534f196cd6e88d4388b.glb",
  "/rpm-assets/glb/65bfd51271a29328533a8f13.glb",
  "/rpm-assets/glb/65bfd6cc99ee375dcfb45d1f.glb",
  "/rpm-assets/glb/65bfd84c99ee375dcfb46610.glb",
  "/rpm-assets/glb/65bfda3d5bfe15dcc6891488.glb",
  "/rpm-assets/glb/65bfdb7e5bfe15dcc6891bb1.glb",
  "/rpm-assets/glb/65bfdc757624741a0cdc0196.glb",
  "/rpm-assets/glb/65bfed9071a29328533b19dd.glb",
  "/rpm-assets/glb/65bfef3a5bfe15dcc68988e9.glb",
  "/rpm-assets/glb/65bffb105bfe15dcc689cb28.glb",
  "/rpm-assets/glb/65bffb5e7624741a0cdcad46.glb",
  "/rpm-assets/glb/65c24855f196cd6e88ccbd7d.glb",
  "/rpm-assets/glb/65c24a0bbee65ecd7a10add5.glb",
  "/rpm-assets/glb/65c24918cb01177237f58842.glb",
  "/rpm-assets/glb/65c2498499ee375dcfc4686d.glb",
  "/rpm-assets/glb/65c24ae25bfe15dcc6991d98.glb",
  "/rpm-assets/glb/65c24c2271a29328534ad1e8.glb",
  "/rpm-assets/glb/65c24d2777c22d1745b9202a.glb",
  "/rpm-assets/glb/65c24db05bfe15dcc6994686.glb",
  "/rpm-assets/glb/65c24e3cf821534228386106.glb",
  "/rpm-assets/glb/65c24eed71a29328534af632.glb",
  "/rpm-assets/glb/65c51adb7299ca6a46af2d59.glb",
];

export const doctorAvatarLibrary: string[] = [
  "/rpm-assets/glb/65c24e3cf821534228386106.glb",
  "/rpm-assets/glb/665754d8b490861c5f1bfbe4.glb",
  "/rpm-assets/glb/65d8e94bee35cc910286cf6d.glb",
  "/rpm-assets/glb/690659b012a04a26c24ddcac.glb",
  "/rpm-assets/glb/65d8e8077fe6ce384b65f613.glb",
  "/rpm-assets/glb/665757d936c854537e1f8954.glb",
  "/rpm-assets/glb/6657582b36c854537e1f8d7e.glb",
  "/rpm-assets/glb/665758e436c854537e1f96f5.glb",
  "/rpm-assets/glb/665762a8b490861c5f1c8b59.glb",
  "/rpm-assets/glb/665763024e82c50acce160ae.glb",
  "/rpm-assets/glb/670596cfb2e1e0e3fb46308f.glb",
  "/rpm-assets/glb/67059724744a89177daefcf7.glb",
  "/rpm-assets/glb/670597c6954244e59c3a52be.glb",
  "/rpm-assets/glb/6705984cce89b6f364c1bbd2.glb",
  "/rpm-assets/glb/670595ffd3e411db45b97f56.glb",
];

// Note: GCP bucket doesn't have /rpm-assets prefix, localhost does
const glbPath = (id: string) => RPM_ASSETS_BASE_URL ? `/glb/${id}.glb` : `/rpm-assets/glb/${id}.glb`;
const pngPath = (id: string) => RPM_ASSETS_BASE_URL ? `/png/${id}.png` : `/rpm-assets/png/${id}.png`;

export const defaultAvatarProvider = `${RPM_ASSETS_BASE_URL}${glbPath('665757d936c854537e1f8954')}`;

export const defaultAvatarClient = `${RPM_ASSETS_BASE_URL}${glbPath('65bfda3d5bfe15dcc6891488')}`;

export const defaultAvatarProviderPng = `${RPM_ASSETS_BASE_URL}${pngPath('665757d936c854537e1f8954')}`;

export const defaultAvatarClientPng = `${RPM_ASSETS_BASE_URL}${pngPath('65bfda3d5bfe15dcc6891488')}`;
